/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom"
import Breadcrumb from "../Breadcrumb";
import Card from "../Card";
import FormInput from "../FormInput";
import LoadingAlert from "../LoadingAlert";
import { qreq } from "../../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { SidebarGlobal } from "../_SidebarGlobal";
import MessageDialog from "../MessageDialog";
import React from "react";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import HTMLEditor from "../HTMLEditor";
import UploadPad from "../UploadPad";
import Icon from "../Icon";
import AppActions from "../AppActions";
import L from "../Lang";

class WorkorderNew extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {
                dueDate: new Date(),
                startDate: new Date(),
                attachments: []
            }
        };

        this.submitRef = React.createRef();
    }

    async componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" onClick={() => this.submitRef.current.click()}>
            <FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = () => {
        this.setState({ loading: true });
        if (this.props.params.id) {
            qreq.get('/api/workorder/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item)
                    this.setState({ item: j.item });
                this.setState({ loading: false });
            }, e => {
                this.unkownErrorCallback();
                this.goBack();
                this.setState({ loading: false });
            });
        }
        else
            this.setState({ item: {}, loading: false });
    }


    submit = (e) => {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };
        console.log('info', item);

        this.setState({ saving: true });


        qreq.post('/api/workorder/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    changeInfo = (a, b) => {
        let item = { ...this.state.item };
        item[a] = b;
        this.setState({ item });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    toggleShowAttachment = () => {
        this.setState({ showAddAttachment: !this.state.showAddAttachment });
    }

    render() {


        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Work Order</L></h1><LoadingAlert /></div>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Work Order</L></h1>
                <Breadcrumb path={[['Work Orders', '/workorder'], [this.props.params.id ? 'Edit' : 'New']]} />
                <AppActions>
                    <button type="submit" className="btn btn-lg btn-success">
                        <Icon icon="faSave" /> <L>Submit</L></button>
                </AppActions>
                <div className="row">
                    <div className="col-lg-12">
                        <Card title="Information">
                            <div className="row">
                                <div className="col-md-8">
                                    <FormInput model={this.state.item} name="name" label="Workorder Name" type="text"
                                        required onChange={this.change} />
                                </div>
                            </div>

                            <HTMLEditor linkValue value={this.state.item.summary} className="form-control"
                                onChange={(v) => this.changeInfo('summary', v)} disabled={this.props.locked} />

                            {!this.state.showAddAttachment ? <button type="button" className="btn btn-secondary" onClick={this.toggleShowAttachment}>
                                <Icon icon="faLink" /> <L>Add Attachment</L></button>
                                : <UploadPad
                                    item={this.state.item}
                                    name="attachments"
                                    onUploadBegin={() => this.setState({ uploading: true })}
                                    onUploadEnd={() => this.setState({ uploading: false })}
                                />}
                        </Card>
                    </div>
                </div>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>
                    <div className="d-none">
                        <button ref={this.submitRef} type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(WorkorderNew);